var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud/20/Docs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.5 4.5)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.243 0h2.768c.516 0 .695.019.893.064.198.046.373.119.545.226.173.108.312.221.677.586l2.998 2.998c.365.365.478.504.586.677.107.172.18.347.226.545.045.198.064.377.064.893v5.768c0 .78-.081 1.063-.234 1.348a1.59 1.59 0 01-.661.661c-.285.153-.568.234-1.348.234H2.243c-.78 0-1.063-.081-1.348-.234a1.59 1.59 0 01-.661-.661C.08 12.82 0 12.537 0 11.757V2.243C0 1.463.081 1.18.234.895A1.59 1.59 0 01.895.234C1.18.08 1.463 0 2.243 0z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5H7.282c-.446 0-.607-.046-.77-.134a.909.909 0 01-.378-.378C6.046 4.325 6 4.164 6 3.718V0",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.404 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.096 3v-.757c0-.78.081-1.063.234-1.348A1.59 1.59 0 01.99.234C1.277.08 1.56 0 2.34 0h2.767c.516 0 .695.019.893.064.198.046.373.119.545.226.173.108.312.221.677.586l2.998 2.998c.365.365.478.504.586.677.108.172.18.347.226.545.045.198.064.377.064.893v5.768c0 .78-.081 1.063-.234 1.348a1.59 1.59 0 01-.661.661c-.285.153-.568.234-1.348.234H5.096",
    id: "Path",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 .064l.096.026v3.628c0 .39.036.563.103.709l.03.061a.915.915 0 00.379.378c.163.088.324.134.77.134h3.629l.025.096c.045.198.064.377.064.893v5.768c0 .78-.081 1.063-.234 1.348a1.59 1.59 0 01-.661.661c-.285.153-.568.234-1.348.234H5.096V8.99c0-.46-.015-.652-.05-.828l-.014-.066a1.741 1.741 0 00-.226-.545c-.108-.173-.22-.312-.586-.677L1.222 3.876C.857 3.511.718 3.398.545 3.29A1.741 1.741 0 000 3.064l.096.026v-.847c0-.78.081-1.063.234-1.348A1.59 1.59 0 01.99.234C1.277.08 1.56 0 2.34 0h2.767c.516 0 .695.019.893.064z",
    id: "Combined-Shape",
    fill: "currentColor",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.096 5H7.378c-.446 0-.607-.046-.77-.134a.909.909 0 01-.378-.378c-.087-.163-.134-.324-.134-.77V0",
    id: "Path",
    stroke: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments20);
export default __webpack_public_path__ + "static/media/documents-20.a1228a1b.svg";
export { ForwardRef as ReactComponent };